import { Environments, findConference } from '@goto/join-box-api'
import { getLocationOrigin } from '../common/dom-helpers'
import { Environment, environment } from '../environments'
import { navigateToUrl } from './helpers'
import { getShellLogger } from './logger'

export const navigateToMeeting = (id: string) => {
  const origin = getLocationOrigin()
  const meetingUrl = `${origin}/meeting/${id}`
  navigateToUrl(meetingUrl)
}

export const convertEnvironment = (currentEnvironment: Environment): Environments => {
  switch (currentEnvironment) {
    case Environment.ED:
      return Environments.ED
    case Environment.PROD:
    case Environment.NIGHTLY:
      return Environments.LIVE
    case Environment.STAGING:
      return Environments.STAGE
    case Environment.RC:
      return Environments.RC
  }
}

export const validateMeetingId = async (meetingNameOrId: string, clientName: string): Promise<string | undefined> => {
  const currentEnvironment = environment().environment
  try {
    const response = await findConference(meetingNameOrId, {
      clientName,
      environment: convertEnvironment(currentEnvironment),
      retries: 3,
    })
    return response.meetingId
  } catch (e) {
    getShellLogger().warn('Cannot validate meetingId', e)
    return undefined
  }
}
